import { TemplateDefaults } from "../../TemplateDefaults";
import { Box2, Vector2 } from "three";
import { DOMHitTest } from "../../../library-js/dom-tools/DOMHitTest";
import { Events, OnDrag, OnMouseEnter, OnMouseLeave, OnMouseMove } from "../../../library-js/dom-tools/EventListeners";
import { DragData } from "../../../library-js/dom-ui/basics/DragData";
import { NodeGraphView } from "../NodeGraphView";
import { NodeGraphNode as NodeGraphNode } from "./NodeGraphNode";
import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { NodeGraphEdge } from "./NodeGraphEdge";
import { IncrementalIDGenerator } from "../../../library-js/random/IncrementalIDGenerator";
import { OnAnimationFrame } from "../../../library-js/animation/OnAnimationFrame";
import { NGEdgeCreator } from "../interactions/NGEdgeCreator";
import { NodeGraphEvent } from "../interactions/NodeGraphEvent";
import { NodeGraphInteraction } from "../interactions/NodeGraphInteraction";
import { NodeGraphComponent } from "./NodeGraphComponent";
import { NodeGraph } from "./NodeGraph";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";

export class NodeGraphReference
{
  static readonly attribute = new ElementAttribute( "reference" );

  _id:string;
  _nodeGraph:NodeGraph;

  setID( nodeGraph:NodeGraph )
  {
    if ( this._nodeGraph === nodeGraph )
    {
      return;
    }

    this._nodeGraph = nodeGraph;
    this._id = this._nodeGraph._ensureID( this );
  }

  setSelectionState( selected:boolean )
  {

  }


  static find( e:Element ):string
  {
    while ( e )
    {
      if ( NodeGraphReference.attribute.in( e ) )
      {
        return NodeGraphReference.attribute.from( e );
      }

      e = e.parentElement;
    }

    return null;
  }

  static findReference( e:Element, ng:NodeGraph ):NodeGraphReference
  { 
    let id = NodeGraphReference.find( e );
    
    return ng.get( id )
  }
}
